/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-08T19:23:44.666
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'financial-FinancialClaimCancellationApply-'

export default 
{
path: '/financial/financialclaimcancellationapply',
name: 'financial-FinancialClaimCancellationApply',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}FinancialClaimCancellationApply-index',

meta:{
...meta,
title: '财务认领跨月作废申请'
},

component: () => import('@/pages/financial/financialclaimcancellationapply/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}FinancialClaimCancellationApply-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务认领跨月作废申请编辑'
},

component: () => import('@/pages/financial/financialclaimcancellationapply/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}FinancialClaimCancellationApplydetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务认领跨月作废申请新增'
},

component: () => import('@/pages/financial/financialclaimcancellationapply/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}FinancialClaimCancellationApplyView',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务认领跨月作废申请详情查看'
},

component: () => import('@/pages/financial/financialclaimcancellationapply/detail-view') ,
},
]
};
